import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import icons from '../../../../data/icons';
import { scrollToElement } from '../../../helpers/scrollToElement';

const API_URL = process.env.REACT_APP_CMS;

const FormOption = ({
    option, handleChangeRadio, error, radioButton, total
}) => (
    <div className={ cx(
        'estimation-form-container',
        { 'animation-in': radioButton === option.translations.name },
        { 'container-2': total === 2 },
        { 'container-3': total >= 3 && total % 3 === 0 },
        { 'container-4': total >= 3 && total % 3 === 1 },
        { 'container-5': total >= 3 && total % 3 === 2 }
    ) }
    >
        <input
          type="radio"
          name="radioButton"
          id={ option.key }
          value={ option.key }
          onChange={ (e) => { handleChangeRadio(e); scrollToElement('pricing-scroll'); } }
          checked={ radioButton === option.key }
          className={ cx('estimation-form-input', { error: error.name }) }
        />
        <label htmlFor={ option.key } className="estimation-form-item">
            <span className="label">
                <img
                  className="icon"
                  alt="pricing type icon"
                  src={ `${ API_URL }/assets/${ option.icon }` }
                />
                <p
                  className="title"
                >
                    {option.translations.name}
                </p>
                <span className="check" dangerouslySetInnerHTML={ { __html: icons.estimation.check } }/>
            </span>
        </label>
    </div>
);

FormOption.propTypes = {
    option: PropTypes.shape({
        translations: PropTypes.shape({
            name: PropTypes.string,
            description: PropTypes.string
        }),
        icon: PropTypes.string,
        pricingItems: PropTypes.arrayOf(PropTypes.shape())
    }).isRequired,
    handleChangeRadio: PropTypes.func.isRequired,
    error: PropTypes.shape().isRequired,
    radioButton: PropTypes.string.isRequired,
    total: PropTypes.number.isRequired
};

export default FormOption;



// WEBPACK FOOTER //
// ./src/components/content/estimation/form/FormOption.jsx